module.exports = __webpack_public_path__ + "img/error.0603d166.png";